module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/down-arrow-nudge-f5b8b70e606974f2d3a106a2367797d5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/down-arrow-nudge.svg
// module id = gGxR
// module chunks = 24